// components/JsonSchemaSection.tsx
import React from 'react';
import Form from '@rjsf/core';
import validator from '@rjsf/validator-ajv8';
// ייבוא הקסטומיזציות שלנו
import { customWidgets } from '@/components/rjsf-customizations/CustomWidgets';
import { customTemplates /*, customBaseComponents */ } from '@/components/rjsf-customizations/CustomTemplates';

// ייבוא טיפוסים רלוונטיים מ-RJSF
import { RJSFValidationError, StrictRJSFSchema, UiSchema, FormProps as RJSFFormProps } from '@rjsf/utils';

// הגדרת הטיפוסים לפרופס של הרכיב העוטף
interface JsonSchemaSectionProps<T = any, S extends StrictRJSFSchema = StrictRJSFSchema, U extends UiSchema = UiSchema> {
    schema: S;
    uiSchema?: U;
    value: T;
    onChange: (data: T | undefined) => void;
    onErrorsChange?: (errors: RJSFValidationError[]) => void;
}

/**
 * רכיב עוטף עבור RJSF לשימוש בתוך react-hook-form,
 * המשתמש בווידג'טים ותבניות מותאמים אישית של Shadcn.
 */
export function JsonSchema<T = any, S extends StrictRJSFSchema = StrictRJSFSchema, U extends UiSchema = UiSchema>({
    schema,
    uiSchema = {},
    value,
    onChange,
    onErrorsChange,
}: JsonSchemaSectionProps<T, S, U>) {

    const handleRjsfChange: RJSFFormProps<T, S, U>['onChange'] = (edit) => {
        // edit.formData הוא T | undefined. העבר אותו כמות שהוא.
        onChange(edit.formData);
        if (onErrorsChange) {
            // edit.errors הוא RJSFValidationError[]
            onErrorsChange(edit.errors || []); // וודא שזה מערך גם אם RJSF העביר undefined
        }
    };

    const handleRjsfError: RJSFFormProps<T, S, U>['onError'] = (errors) => {
        if(onErrorsChange) {
            onErrorsChange(errors || []); // וודא שזה מערך
        }
    };


    // חשוב מאוד: tagName="div" מונע מ-RJSF לרנדר תגית <form> משלו.
    return (
        <div className="json-schema-section col-span-2"> {/* עוטף את החלק של RJSF */}
            <Form<T, S, U>// הגדר טיפוסים לפורם של RJSF
                schema={schema}
                uiSchema={{
                    "ui:submitButtonOptions": { "norender": true },
                    ...uiSchema // שלב את ה uiSchema שהתקבל בפרופס
                }}
                formData={value} // הנתונים מגיעים מ-RHF דרך ה Controller
                validator={validator}
                onChange={handleRjsfChange} // דווח על כל שינוי ל-RHF ולמעלה
                onError={handleRjsfError} // דווח על שגיאות גם מאירוע onError
                onSubmit={(e) => {
                    console.log("RJSF onSubmit called - preventing default.");
                    if (e && e.preventDefault) {
                        e.preventDefault();
                    }
                }}
                tagName="div" // מונע רנדור תגית <form>
                className="space-y-2"
                widgets={customWidgets} // <-- העברת הווידג'טים המותאמים אישית
                templates={customTemplates} // <-- העברת התבניות המותאמות אישית
                // components={{ ...customBaseComponents }} // אם יצרת רכיבים בסיסיים מותאמים אישית
            >
                <div>{/* ריק או כל תוכן שתצטרך להוסיף בתוך הפורם RJSF */}</div>
            </Form>
        </div>
    );
}